import React from 'react'
import { Label } from '@hospitalrun/components'
import './input.scss'
import { toLocaleString } from 'scheduling/appointments/util/scheduling-appointment.util'
import { ComponentWrapperWithAITracking } from 'analytics/AppInsights'
import { DatePicker, Space, DatePickerProps } from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import classes from '../../style.module.scss'
import { DateUtil } from 'utils/DateUtil'

interface Props {
  name: string
  label: string
  value: Date | undefined
  isEditable?: boolean
  onChange?: (date: Date) => void
  isRequired?: boolean
  feedback?: string
  isInvalid?: boolean
  maxDate?: Date
  showYearDropdown?: boolean
  disabled?: boolean
}

const DatePickerWithLabelFormGroup = (props: Props & DatePickerProps) => {
  const {
    onChange,
    label,
    name,
    isEditable,
    value,
    isRequired,
    feedback,
    isInvalid,
    maxDate,
    showYearDropdown,
    disabled,
  } = props
  const id = `${name}DatePicker`
  const { t } = useTranslation()
  console.log(feedback, maxDate, showYearDropdown)

  return (
    <div className="form-group">
      <Label
        className={classes.label}
        text={label}
        htmlFor={id}
        isRequired={isRequired && isEditable}
      />
      {isEditable ? (
        <>
          <Space direction="vertical" className="w-100">
            <DatePicker
              className={`datePicker ${isInvalid && 'isInvalid'}`}
              disabled={!isEditable || disabled}
              format={DateUtil.getFormatDateSimple()}
              placeholder={t('selectDate')}
              onChange={inputDate => {
                if (onChange && inputDate) {
                  let date: Date = new Date(inputDate.toISOString())
                  onChange(date)
                }
              }}
              getPopupContainer={(triggerNode: any) => {
                return triggerNode.parentNode
              }}
              {...props}
              value={value ? moment(value) : undefined}
            />
          </Space>
        </>
      ) : (
        <div className="text-secondary">
          {value ? toLocaleString(new Date(value.toString())) : null}
        </div>
      )}
    </div>
  )
}

export default ComponentWrapperWithAITracking(
  DatePickerWithLabelFormGroup,
  'DateTimePickerWithLabelFormGroup',
)
